<template>
  <div class="vault-details">
    <div
      class="text-6 gray--text d-flex align-center clickable"
      @click="$router.push({ name: 'Yield' })"
    >
      <v-icon small class="gray--text">mdi-chevron-left</v-icon>
      <span class="ml-1">Go Back</span>
    </div>
    <vault-overview :vaultInfo="vaultInfo" class="mt-7" />
    <v-divider class="mt-4 border-vault"></v-divider>
    <div class="mt-10">
      <about :vaultInfo="vaultInfo" />
      <v-divider class="mt-10 mb-10 border-vault"></v-divider>
      <your-balance :vaultInfo="vaultInfo" />
      <v-divider class="mt-10 mb-10 border-vault"></v-divider>
      <about-asset :vaultInfo="vaultInfo" />
      <v-divider class="mt-10 mb-10 border-vault"></v-divider>
      <div class="d-none d-md-block">
        <div class="text-4 mb-10">Explore More</div>
        <link-cards />
      </div>
    </div>
    <c-fullscreen-modal
      v-if="shouldShowDepositModal"
      @back="hideDepositModal"
      @close="hideDepositModal"
    >
      <deposit />
    </c-fullscreen-modal>
    <c-fullscreen-modal
      v-if="shouldShowWithdrawModal"
      @back="hideWithdrawModal"
      @close="hideWithdrawModal"
    >
      <withdraw />
    </c-fullscreen-modal>
    <c-fullscreen-modal
      v-if="shouldShowMigrateModal"
      @back="hideMigrateModal"
      @close="hideMigrateModal"
    >
      <migrate />
    </c-fullscreen-modal>
    <revoke-access-modal
      v-if="vaultInfo.identity === 'ETH-V3'"
      :vaultInfo="vaultInfo"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VaultOverview from "../components/VaultOverview";
import YourBalance from "./YourBalance";
import About from "./About";
import AboutAsset from "./AboutAsset";
import Deposit from "../deposit";
import Withdraw from "../withdraw";
import Migrate from "../migrate";
import LinkCards from "@/views/explore/components/LinkCards";
import RevokeAccessModal from "./RevokeAccessModal";

export default {
  components: {
    VaultOverview,
    YourBalance,
    About,
    AboutAsset,
    Deposit,
    Withdraw,
    Migrate,
    LinkCards,
    RevokeAccessModal,
  },
  data: () => ({
    shouldShowDepositModal: false,
    shouldShowWithdrawModal: false,
    shouldShowMigrateModal: false,
  }),
  computed: {
    ...mapGetters({
      getVaultByIdentity: "projectConfig/getVaultByIdentity",
      projects: "projectConfig/projects",
      walletSelected: "userWallets/walletSelected",
    }),
    vaultInfo() {
      const theVault = this.getVaultByIdentity(this.$route.params.vault);
      return {
        type: theVault.vaultType,
        token: theVault.coin,
        ...theVault,
      };
    },
  },
  methods: {
    hideDepositModal() {
      this.shouldShowDepositModal = false;
      this.resetAction();
    },
    hideWithdrawModal() {
      this.shouldShowWithdrawModal = false;
      this.resetAction();
    },
    hideMigrateModal() {
      this.shouldShowMigrateModal = false;
      this.resetAction();
    },
    resetAction() {
      this.$router.replace({
        name: "VaultDetails",
        params: { vault: this.vaultInfo.identity.toLowerCase() },
      });
    },
  },
  mounted() {
    this.$store.dispatch(
      "projectConfig/setCurrentProject",
      this.projects.find(item => item.name === "ethereum")
    );
    this.$store.dispatch("productStats/fetchVaultsStats");
    this.$store.dispatch("productStats/fetchVaultsStrategy");
  },
  watch: {
    walletSelected: {
      immediate: true,
      handler({ address, coin_network } = {}) {
        if (address && coin_network === "ethereum") {
          this.$store.dispatch("vaults/fetchBalances");
          this.$store.dispatch("vaults/fetchWethV3ZapAllowance");
        }
      },
    },
    $route: {
      immediate: true,
      handler() {
        if (this.$route.query.action === "deposit") {
          this.shouldShowDepositModal = true;
        }
        if (this.$route.query.action === "withdraw") {
          this.shouldShowWithdrawModal = true;
        }
        if (
          this.$route.query.action === "migrate" &&
          this.vaultInfo.migrationRequired
        ) {
          this.shouldShowMigrateModal = true;
        }
      },
    },
  },
};
</script>
